<template>
  <div>
    <TheHotelCalendar
      @create-new-reservation="openCreateNewModal"
      @block-dates="openBlockModal"
      @open-legend="openLegendModal"
      ref="calendar"
    />
    <modal
      name="create-new"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
    >
      <div class="popup-new">
        <button @click="$modal.hide('create-new')" class="popup-new__close" type="button"></button>
        <div class="popup-new__title">Create reservations | <span>{{ property.name }}</span></div>
        <div class="popup-new__body">
          <AppFlexGrid :rows="[[1, 1], [1, 1], [1, 1]]">
            <template #col-1-1>
              <app-form-field label="Status" class="family" required>
                <app-select
                  v-model="form_new_create.status"
                  :options="reservation_status_options"
                  :clearable="false"
                  placeholder="Choose Status"
                  class="family"
                  :error="$v.form_new_create.status.$error"
                />
                <template #error>
                  <div v-if="$v.form_new_create.status.$dirty && !$v.form_new_create.status.required">Required field</div>
                </template>
              </app-form-field>
            </template>
            <template #col-1-2>
              <app-form-field
                v-if="form_new_create.status && !!form_new_create.status.deadline"
                label="Deadline"
                class="family"
                required
              >
                <app-date-picker
                  v-model="form_new_create.deadline"
                  placeholder="Deadline"
                  class="family"
                  :error="$v.form_new_create.deadline.$error"
                />
                <template #error>
                  <div v-if="$v.form_new_create.deadline.$dirty && !$v.form_new_create.deadline.required">Required field</div>
                </template>
              </app-form-field>
            </template>
            <template #col-2-1>
              <app-form-field label="Group name" label-for="group_name" class="family" required>
                <app-input
                  v-model="form_new_create.group_name"
                  id="group_name"
                  placeholder="Group name"
                  name="group_name"
                  class="family"
                  :error="$v.form_new_create.group_name.$error"
                />
                <template #error>
                  <div v-if="$v.form_new_create.group_name.$dirty && !$v.form_new_create.group_name.required">Required field</div>
                </template>
              </app-form-field>
            </template>
            <template #col-2-2>
              <app-form-field label="Source" class="family" required>
                <app-select
                  v-model="form_new_create.source"
                  :options="sources_options"
                  :clearable="false"
                  placeholder="Source"
                  class="family"
                  :error="$v.form_new_create.source.$error"
                />
                <template #error>
                  <div v-if="$v.form_new_create.source.$dirty && !$v.form_new_create.source.required">Required field</div>
                </template>
              </app-form-field>
            </template>
            <template #col-3-1>
              <app-form-field label="Meal Plan" class="family" required>
                <HMMealPlanList
                  v-model="form_new_create.meal_plan"
                  :mealPlanTypes="mealPlanTypes"
                  :error="$v.form_new_create.meal_plan.$error"
                />
                <template #error>
                  <div v-if="$v.form_new_create.meal_plan.$dirty && !$v.form_new_create.meal_plan.required">Required field</div>
                </template>
              </app-form-field>
            </template>
            <template #col-3-2>
              <app-form-field label="Source Reservation ID" label-for="source_id" class="family">
                <app-input
                  v-model="form_new_create.external_id"
                  id="source_id"
                  name="source_id"
                  class="family"
                />
              </app-form-field>
            </template>
          </AppFlexGrid>
          <hr style="margin-bottom: 20px">
          <AppFlexGrid :rows="[[1, '100px', '222px'], ['240px', '240px', 1], ['max-content']]">
            <template #header-1>
              <h3 class="title title--mb15 title--family title--grey">Room Configuration</h3>
            </template>
            <template #col-1-1>
              <app-select
                v-model="form_new_create.room_category"
                :options="roomCategories"
                :clearable="false"
                placeholder="Select Room"
                class="family"
              />
            </template>
            <template #col-1-2>
              <app-input
                v-model="form_new_create.count"
                type="number"
                id="qty"
                placeholder="Qty"
                name="qty"
                class="family"
              />
            </template>
            <template #col-1-3>
              <app-cells :indent="false" gap="12px">
                <HMAgeAssignment
                  v-if="form_new_create.accomodation_type"
                  @input="rmpShow = true"
                  :accomodation-type="form_new_create.accomodation_type"
                />
                <HMButton
                  @click.native="rmpShow = true"
                  color="#8d95a4"
                  background="linear-gradient(0deg, #D9DFE8 0%, #E4E8EF 100%)"
                  :disabled="!form_new_create.room_category || hasSingleAT"
                >
                  <template v-if="!form_new_create.accomodation_type">
                    <img src="@/assets/img/hm/man.svg" alt="">
                    <span>Configure Room</span>
                  </template>
                  <img v-else src="@/assets/img/hm/pen-grey.svg" alt="">
                </HMButton>
              </app-cells>
            </template>
            <template #col-2-1>
              <div style="position: relative;">
                <app-date-picker
                  @input="onCreateCheckInInput"
                  v-model="form_new_create.check_in"
                  class="family"
                  placeholder="Check-in"
                  :clearable="false"
                  :disabled-date="disablePastDates"
                  :default-value="from_date"
                />
                <img style="position: absolute; top: calc(50% - 5px); right: -16px;" src="@/assets/img/hm/arrow-right-grey.svg" alt="">
              </div>
            </template>
            <template #col-2-2>
              <app-date-picker
                v-model="form_new_create.check_out"
                class="family"
                placeholder="Check-out"
                :clearable="false"
                :disabled="!form_new_create.check_in"
                :disabled-date="disableDatesFromCheckIn"
                :default-value="form_new_create.check_in"
                ref="create_check_out"
              />
            </template>
            <template #col-2-3>
              <HMTower horizontal>
                <template #title>Nights:</template>
                <template #body>
                  <HMChip>
                    {{ calcNumberOfNightsNew || '-' }}
                    <template #icon>
                      <NightsIcon aria-hidden="true"/>
                    </template>
                  </HMChip>
                </template>
              </HMTower>
            </template>
            <template #col-3-1>
              <app-cells :indent="false">
                <HMButton
                  @click.native="addConfigurationToRoomsSummary"
                  color="#8d95a4"
                  background="linear-gradient(0deg, #D9DFE8 0%, #E4E8EF 100%)"
                  :disabled="isAddRoomDisabled || isDuplicateRoomConfig"
                >
                  <img src="@/assets/img/hm/plus-grey.svg" alt="">
                  <span>Add room to reservation</span>
                </HMButton>
                <MiniNotification v-if="isDuplicateRoomConfig" max-width="300px">
                  This room configuration is already added.
                  Change the details to add another.
                </MiniNotification>
              </app-cells>
            </template>
          </AppFlexGrid>
          <hr style="margin-bottom: 20px">
          <h3 class="title title--mb15 title--family title--grey">Rooms Summary</h3>
          <template v-if="rooms.length !== 0">
            <HotelShortRoomCreate
              v-for="(item, index) in rooms"
              :key="`room_${item.room_category?.id}_${item.accomodation_type?.code}_${item.check_in}_${item.check_out}`"
              @update-count="rooms[index].count = Math.max(1, Math.floor(($event || 1)))"
              @delete="rooms.splice(index, 1)"
              :room="item"
              :order-number="index + 1"
            />
          </template>
          <div v-else class="no-rooms">
            <img src="@/assets/img/hm/bed-blue.jpg" alt="" class="no-rooms__img">
            <div class="no-rooms__body">
              <div class="no-rooms__title">There’s no rooms yet</div>
              <div class="no-rooms__text">Rooms will appear here once added</div>
            </div>
          </div>
          <hr style="margin-bottom: 20px; margin-top: 40px">
          <app-cells :indent="false" position="end">
            <HMButton @click.native="onCheckCreateNewForm" :disabled="rooms.length === 0 || $v.form_new_create.$error">
              <template v-if="!isSubmitting">
                Create
              </template>
              <span v-else class="hc-spinner" aria-hidden="true"></span>
            </HMButton>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="block"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      draggable=".popup-new__title"
    >
      <div class="popup-new">
        <button @click="$modal.hide('block')" class="popup-new__close" type="button"></button>
        <div class="popup-new__title">Block Dates | <span>{{ property.name }}</span></div>
        <div class="popup-new__body">
          <AppFlexGrid :rows="[[1], [1], [1, 1], [1]]">
            <template #col-1-1>
              <app-cells :indent="false">
                <app-radio
                  v-for="opt in type_options"
                  :key="opt.value"
                  v-model="form_block.status"
                  :value="opt.value"
                  name="type_status_block"
                  class="family"
                >
                  <template #label>{{ opt.name }}</template>
                </app-radio>
              </app-cells>
            </template>
            <template #col-2-1>
              <app-form-field label="Name" label-for="form_block_name" class="family">
                <app-input
                  v-model="form_block.name"
                  id="form_block_name"
                  placeholder="For example: Renovation"
                  name="form_block_name"
                  class="family"
                />
              </app-form-field>
            </template>
            <template #col-3-1>
              <app-form-field label="From" class="family" style="position: relative">
                <app-date-picker
                  @input="onFromDateChange"
                  v-model="form_block.from_date"
                  :default-value="from_date"
                  :disabled-date="disableBlockPastDates"
                  placeholder="Choose date"
                  class="family"
                />
                <img style="position: absolute; top: calc(50% + 10px); right: -16px;" src="@/assets/img/hm/arrow-right-grey.svg" alt="">
              </app-form-field>
            </template>
            <template #col-3-2>
              <app-form-field label="To" class="family">
                <app-date-picker
                  @input="onToDateChange"
                  v-model="form_block.to_date"
                  :default-value="form_block.from_date"
                  :disabled="!form_block.from_date"
                  :disabled-date="disableBlockDatesFromCheckIn"
                  ref="block_to_date"
                  placeholder="Choose date"
                  class="family"
                />
              </app-form-field>
            </template>
            <template #header-4>
              <div class="title title--mb15 title--family title--grey">Rooms to block</div>
            </template>
            <template #col-4-1>
              <div v-if="rooms_available?.length" class="block-cols">
                <label v-for="room in rooms_available" :key="room.id" class="ccb">
                  <span class="ccb__text">{{ room.room_name }}</span>
                  <input v-model="form_block.rooms" :value="room.id" type="checkbox" class="ccb__input">
                  <span class="ccb__checkmark"></span>
                </label>
              </div>
              <div v-if="!rooms_available" class="no-rooms">
                <img src="@/assets/img/hm/bed-blue.jpg" alt="" class="no-rooms__img">
                <div class="no-rooms__body">
                  <div class="no-rooms__title">Rooms available to block will appear here</div>
                  <div class="no-rooms__text">First you need to select the dates</div>
                </div>
              </div>
              <div v-if="rooms_available && rooms_available.length < 1" class="no-rooms no-rooms--red">
                <img src="@/assets/img/hm/bed-red.jpg" alt="" class="no-rooms__img">
                <div class="no-rooms__body">
                  <div class="no-rooms__title">There’s no available rooms to block</div>
                  <div class="no-rooms__text">Unfortunately there’s no available rooms, please change your dates</div>
                </div>
              </div>
            </template>
          </AppFlexGrid>
          <app-cells :indent="false" position="end">
            <button
              @click="onCheckBlockForm"
              class="hc-button"
              type="button"
              :disabled="!form_block.name && !form_block.from && !form_block.to"
            >
              <template v-if="!isSubmittingBlock">
                Block Rooms
              </template>
              <span v-else class="hc-spinner" aria-hidden="true"></span>
            </button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="legend"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
    >
      <div class="popup-new">
        <button @click="$modal.hide('legend')" class="popup-new__close" type="button"></button>
        <div class="popup-new__title">Legend</div>
        <div class="popup-new__body">
          <TheHCLegend />
        </div>
      </div>
    </modal>
    <div v-if="rmpShow" class="hc-popover" ref="rmp" :style="rmpStyles">
      <div class="hc-popover__body">
        <button @click="rmpShow = false" class="hc-popover__close" type="button">
          <CloseSearch/>
        </button>
        <div class="hc-popover__wrapper">
          <div class="hc-popover__top">
            <div class="hc-popover__title">
              {{ form_new_create.room_category.name }} <span>| Room Configurations</span>
            </div>
          </div>
          <div class="hc-popover__meta">Please select configuration that suits your guests.</div>
          <app-form-field label="Available options:" class="family">
            <div class="hc-popover__scroll">
              <app-cells :indent="false">
                <HMAgeAssignment
                  v-for="item in form_new_create.room_category.accomodation_types"
                  :key="`accomodation_type_${form_new_create.room_category.id}_${item.code}`"
                  @input="rmpShow = false"
                  v-model="form_new_create.accomodation_type"
                  :accomodation-type="item"
                />
              </app-cells>
            </div>
          </app-form-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheHotelCalendar from '@/views/hotel-management/calendar/TheHotelCalendar.vue'
import TheHCLegend from '@/views/hotel-management/calendar/TheHCLegend.vue'
import {
  getHotelManagementMealPlanTypes,
  getHotelManagementSources,
  getHotelManagementReservationStatusV2,
  getHotelManagementRoomCategories,
  postHotelManagementReservationV2,
  getHotelManagementRoomsAvailable,
  postHotelManagementBlocks
} from '@/http'
import { required, requiredIf } from 'vuelidate/lib/validators'
import HMMealPlanList from '@/components/HMMealPlanList.vue'
import CloseSearch from '@/views/hotel-management/calendar/icons/CloseSearch.vue'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'
import HMAgeAssignment from '@/components/HMAgeAssignment.vue'
import HMTower from '@/components/HMTower.vue'
import NightsIcon from '@/views/hotel-management/reservations/detail/icons/NightsIcon.vue'
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'
import HotelShortRoomCreate from '@/components/HotelShortRoomCreate.vue'
import MiniNotification from '@/components/MiniNotification.vue'

export default {
  name: 'HotelManagementCalendar',
  components: {
    MiniNotification,
    HotelShortRoomCreate,
    HMChip,
    NightsIcon,
    HMTower,
    HMAgeAssignment,
    HMButton,
    CloseSearch,
    TheHotelCalendar,
    HMMealPlanList,
    TheHCLegend
  },
  data() {
    return {
      form_new_create: { property: null, deadline: null, check_out: '' },
      rooms: [],
      roomCategories: [],
      reservation_status_options: [],
      mealPlanTypes: [],
      sources_options: [],
      isSubmitting: false,
      isSubmittingBlock: false,
      form_block: { status: 'block', rooms: [], to_date: '' },
      property: {},
      type_options: [{ name: 'Block', value: 'block' }, { name: 'Out of Service', value: 'unavailable' }],
      rooms_available: null,
      rmpShow: false,
      from_date: '',
    }
  },
  validations: {
    form_new_create: {
      status: { required },
      deadline: {
        required: requiredIf(function () { return this.form_new_create.status && !!this.form_new_create.status?.deadline }),
      },
      group_name: { required },
      source: { required },
      meal_plan: { required },
    }
  },
  computed: {
    hasSingleAT() {
      const cat = this.form_new_create && this.form_new_create.room_category
      const list = cat && Array.isArray(cat.accomodation_types) ? cat.accomodation_types : []
      return list.length === 1
    },
    rmpStyles() {
      return {
        left: '50%',
        top: 'calc(50% + 100px)',
        transform: 'translate(-50%, -50%)'
      }
    },
    calcNumberOfNightsNew() {
      if (this.form_new_create.check_in && this.form_new_create.check_out) {
        const date1 = new Date(this.form_new_create.check_in)
        const date2 = new Date(this.form_new_create.check_out)
        const timeDiff = date2.getTime() - date1.getTime()
        return Math.ceil(timeDiff / (1000 * 3600 * 24)) < 0 ? 0 : Math.ceil(timeDiff / (1000 * 3600 * 24))
      } else {
        return ''
      }
    },
    isAddRoomDisabled() {
      const f = this.form_new_create || {}
      const hasCat = !!f.room_category
      const hasQty = Number(f.count) >= 1
      const hasAT = !!f.accomodation_type
      const hasCI = !!f.check_in
      const hasCO = !!f.check_out
      const hasMP = !!f.meal_plan
      return !(hasCat && hasQty && hasAT && hasCI && hasCO && hasMP)
    },
    isDuplicateRoomConfig() {
      const f = this.form_new_create || {}
      if (!f || !f.room_category || !f.accomodation_type || !f.check_in || !f.check_out) return false
      return this.rooms.some(r => this.sameRoomConfig(r, f))
    },
  },
  watch: {
    'form_new_create.room_category': {
      handler (cat) {
        const at = this.form_new_create?.accomodation_type || null

        if (!cat) {
          if (at) this.form_new_create.accomodation_type = null
          return
        }

        const list = Array.isArray(cat.accomodation_types) ? cat.accomodation_types : []

        if (list.length === 1) {
          const only = list[0]
          if (!at || at.code !== only.code) this.form_new_create.accomodation_type = only
          return
        }

        if (at && !this.accomodationTypeBelongs(cat, at)) {
          this.form_new_create.accomodation_type = null
        }
      },
      immediate: false
    },
    'form_new_create.count'(val) {
      if (val === null || val === '') return
      const n = Number(val)
      if (!isFinite(n)) return
      const normalized = n < 1 ? 1 : Math.floor(n)
      if (normalized !== n) this.form_new_create.count = normalized
    },
  },
  methods: {
    sameRoomConfig(a, b) {
      if (!a || !b) return false
      const aCat = a.room_category && a.room_category.id
      const bCat = b.room_category && b.room_category.id
      const aAT = a.accomodation_type && a.accomodation_type.code
      const bAT = b.accomodation_type && b.accomodation_type.code
      const aCI = a.check_in
      const bCI = b.check_in
      const aCO = a.check_out
      const bCO = b.check_out
      return aCat === bCat && aAT === bAT && aCI === bCI && aCO === bCO
    },
    accomodationTypeBelongs(category, at) {
      if (!category || !at) return false
      const list = Array.isArray(category.accomodation_types) ? category.accomodation_types : []
      return list.some(t => t && t.code === at.code)
    },
    addConfigurationToRoomsSummary() {
      this.rooms.push({ ...this.form_new_create })
    },
    normalizeDate(val) {
      const d = new Date(val)
      d.setHours(0, 0, 0, 0)
      return d
    },
    addDays(date, n) {
      const d = new Date(date)
      d.setHours(0, 0, 0, 0)
      d.setDate(d.getDate() + n)
      d.setHours(0, 0, 0, 0)
      return d
    },
    onFromDateChange() {
      this.rooms_available = null
      this.$nextTick(() => {
        this.form_block.to_date = ''
        this.$refs.block_to_date.$children[0].focus()
      })
    },
    onCreateCheckInInput() {
      this.$nextTick(() => {
        this.form_new_create.check_out = ''
        this.$refs.create_check_out.$children[0].focus()
      })
    },
    disablePastDates(date) {
      const d = this.normalizeDate(date)
      const today = this.normalizeDate(new Date())
      return d < today
    },
    disableDatesFromCheckIn(date) {
      const d = this.normalizeDate(date)
      const ci = this.form_new_create && this.form_new_create.check_in ? this.normalizeDate(this.form_new_create.check_in) : null

      if (!ci) return this.disablePastDates(d)

      const max = this.addDays(ci, 10)
      return d <= ci || d > max
    },
    disableBlockPastDates(date) {
      const d = this.normalizeDate(date)
      const today = this.normalizeDate(new Date())
      return d < today
    },
    disableBlockDatesFromCheckIn(date) {
      const d = this.normalizeDate(date)
      const ci = this.form_block && this.form_block.from_date ? this.normalizeDate(this.form_block.from_date) : null

      if (!ci) return this.disablePastDates(d)

      const max = this.addDays(ci, 10)
      return d <= ci || d > max
    },
    async onCheckBlockForm() {
      this.isSubmittingBlock = true
      try {
        await postHotelManagementBlocks({ ...this.form_block, property: this.property.code })
        await this.$refs.calendar?.reloadPeriod()
        this.$modal.hide('block')
      } finally {
        this.isSubmittingBlock = false
      }
    },
    onToDateChange() {
      if (this.form_block.from_date && this.form_block.to_date) {
        getHotelManagementRoomsAvailable({
          from_date: this.form_block.from_date,
          to_date: this.form_block.to_date,
          property: this.property.code,
        })
          .then((res) => { this.rooms_available = res.data })
      } else {
        this.rooms_available = []
      }
    },
    openLegendModal() {
      this.$modal.show('legend')
    },
    openBlockModal({ property, from_date }) {
      this.form_block = { status: 'block', rooms: [], to_date: '' }
      this.rooms_available = null
      this.property = property
      this.from_date = from_date
      this.$modal.show('block')
    },
    onCheckCreateNewForm() {
      this.$v.form_new_create.$touch()
      if (this.$v.form_new_create.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendCreateNewForm()
      }
    },
    sendCreateNewForm() {
      this.isSubmitting = true
      postHotelManagementReservationV2(this.normalizeNewCreateForm(this.form_new_create))
        .finally(() => { this.isSubmitting = false })
        .then(response => {
          this.$router.push({
            name: 'hotel-management-reservations-detail-reservation',
            params: { id: response.data.id }
          })
        })
    },
    normalizeNewCreateForm(originalForm) {
      const form = {}

      form.property = originalForm.property.code
      form.source = originalForm.source.id
      form.group_name = originalForm.group_name
      form.status = originalForm.status.code
      form.deadline = originalForm.deadline || null
      form.meal_plan = originalForm.meal_plan.code
      form.external_id = originalForm.external_id
      form.short_rooms = this.rooms.map(({ count, accomodation_type, check_in, check_out, room_category, ...rest }) => (
        {
          room_category: room_category.id,
          check_in,
          check_out,
          count,
          accomodation_type: accomodation_type.code,
        }
      ))

      return form
    },
    openCreateNewModal({ property, from_date }) {
      this.form_new_create = { property, deadline: null, check_out: '' }
      this.rooms = []
      this.property = property
      this.from_date = from_date
      this.$v.form_new_create.$reset()

      Promise.all([
        getHotelManagementReservationStatusV2({ create: true }),
        getHotelManagementMealPlanTypes(),
        getHotelManagementSources(),
        getHotelManagementRoomCategories({ property: property.code }),
      ])
        .then(response => {
          this.reservation_status_options = response[0].data
          this.mealPlanTypes = response[1].data
          this.sources_options = response[2].data
          this.roomCategories = response[3].data

          this.$nextTick(() => {
            this.$modal.show('create-new')
          })
        })
    },
  }
}
</script>

<style scoped>
.hc-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 5px 12px;
  border-radius: 8px;
  background: linear-gradient(180deg, #E3E8D9 0%, #DCE4CD 100%);
  color: #698262;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
  transition: filter 0.3s;
}

.hc-button:hover {
  filter: brightness(0.95);
}

.hc-button:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.hc-spinner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid rgba(105, 130, 98, .35);
  border-top-color: #698262;
  animation: hc-spin .8s linear infinite;
}

@keyframes hc-spin {
  to {
    transform: rotate(360deg);
  }
}

hr {
  padding: 0;
  height: 0;
  border: none;
  border-top: 1px solid #e9e9e9;
}

.block-cols{
  column-count: 3;
  column-gap: 15px;
}

.ccb {
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding-left: 25px;
  cursor: pointer;
  user-select: none;
  break-inside: avoid;
}

.ccb .ccb__input {
  position: absolute;
  overflow: hidden;
  margin: -1px;
  width: 1px;
  height: 1px;
  clip: rect(0 0 0 0);
}

.ccb .ccb__input:checked ~ .ccb__checkmark {
  border-color: #77b017;
  background-color: #77b017;
}

.ccb .ccb__input:checked ~ .ccb__checkmark:after {
 content: '';
}

.ccb__checkmark {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1px;
  left: 0;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d3d3d3;
  box-sizing: border-box;
  border-radius: 4px;
}

.ccb__checkmark:after {
  content: none;
  width: 8px;
  height: 6px;
  background-image: url("~@/assets/img/checkbox-checked.svg");
  background-repeat: no-repeat;
}

.ccb__text {
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

</style>